import { motion } from "framer-motion";
import { IGeneratedData } from "Interfaces/interface.myprofile";
import { Combine, LayoutGrid } from "lucide-react";
import { useAppSelector } from "store/hooks/hooks";
import { selectUserCatalogs } from "store/slices/catalogSlice";
import { selectUserMockups } from "store/slices/mockupSlice";

const ToolsStats = () => {
  const userCatalogs = useAppSelector(selectUserCatalogs);
  const userMockups = useAppSelector(selectUserMockups);

  const data: IGeneratedData[] = [
    {
      id: 1,
      dataName: "Saved Catalogs",
      dataStored: Array.isArray(userCatalogs) ? userCatalogs.length : 0,
      icon: <LayoutGrid size={20} className="text-blue-500" />,
    },
    {
      id: 2,
      dataName: "Saved Mockups",
      dataStored: Array.isArray(userMockups) ? userMockups.length : 0,
      icon: <Combine size={20} className="text-blue-500" />,
    },
    // {
    //   id: 3,
    //   dataName: "Enquiry raised",
    //   dataStored: userLogos.length > 0 ? userLogos.length : 0,
    //   icon: <MessageSquareMore size={20} className="mr-3 text-blue-500" />,
    // },
  ];

  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-3 md:p-6">
        {data.map((ele, index) => (
          <motion.div
            key={ele.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="group p-3 md:p-6 bg-white/70 backdrop-blur-sm rounded-2xl border border-white/20 shadow-sm hover:shadow-xl transition-all duration-300 hover:scale-105"
          >
            <div className="flex items-center gap-4">
              <div className="p-3 bg-blue-100 rounded-xl group-hover:bg-blue-200 transition-colors duration-300">
                {ele.icon}
              </div>
              <div>
                <div className="text-3xl font-bold text-gray-800 mb-1 font-inter">
                  {ele.dataStored}
                </div>
                <div className="text-sm font-medium text-gray-600 uppercase tracking-wide font-inter">
                  {ele.dataName}
                </div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </>
  );
};

export default ToolsStats;
